import React from 'react';
import MagicForm from '../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import { User } from '../../../../../graphql/graphql';
import usePatientAddressContainer from '../../../Hooks/usePatientAddressContainer';
import { useEffectAsync } from '../../../../../helpers';
import Loading from '../../../../../Components/Loading';

interface Props {
	onSubmit: (values: any) => void;
	user: User;
}

const formScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT_FIELD,
		key: 'salutationBefore',
		title: 'component.patientProfileEdit.salutationBefore',
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'firstName',
		title: 'component.patientProfileEdit.firstName',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'middleName',
		title: 'component.patientProfileEdit.middleName',
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'fatherLastName',
		title: 'component.patientProfileEdit.fatherLastName',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'motherLastName',
		title: 'component.patientProfileEdit.motherLastName',
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'lastName',
		title: 'component.patientProfileEdit.lastName',
	},
	{
		type: MagicField.DATEPICKER,
		key: 'birthDate',
		title: 'component.patientProfileEdit.birthDate',
		settings: {
			required: true,
			rules: [
				{
					rule: 'max',
					value: 'today',
				},
			],
		},
	},
	{
		type: MagicField.GENDER,
		key: 'gender',
		title: 'component.patientProfileEdit.gender',
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'historyClinicNumber',
		title: 'component.patientProfileEdit.historyClinicNumber',
	},
	{
		type: MagicField.EMAIL,
		key: 'email',
		title: 'component.patientProfileEdit.email',
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.PHONE_NUMBER,
		key: 'phoneNumber',
		title: 'component.patientProfileEdit.phone',
		settings: {
			required: true,
		},
	},
];

const PatientProfileEditMexico: React.FC<Props> = ({ onSubmit, user }) => {
	const { addAddressContainerToScheme, isLoading } =
		usePatientAddressContainer();
	const defaultValues = {
		firstName: user.profile?.firstName,
		salutationBefore: user.profile?.salutationBefore,
		middleName: user.profile?.middleName,
		fatherLastName: user.profile?.fatherLastName,
		motherLastName: user.profile?.motherLastName,
		lastName: user.profile?.lastName,
		address: user.profile?.address,
		//@ts-ignore
		historyClinicNumber: user.meta?.historyClinicNumber,
		email: user?.email,
		phoneNumber: user?.phoneNumber,
		birthDate: user.profile?.birthDate,
		gender: user?.profile?.gender,
	};

	const handleSubmit = (values: any) => {
		if (values?.gender?.value) {
			values.gender = values.gender.value;
		}
		onSubmit(values);
	};

	useEffectAsync(async () => {
		if (!formScheme.some(item => item.key === 'address')) {
			await addAddressContainerToScheme(formScheme);
		}
	});

	if (isLoading) {
		return <Loading />;
	}

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			defaultValues={defaultValues || {}}
			showCharCounter={false}
		/>
	);
};

export default PatientProfileEditMexico;
